var _circle, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8392,
    cy: 12.0003,
    r: 9.33333,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8429 14.5131C12.4466 14.5131 12.125 14.2316 12.125 13.8849V7.60281C12.125 7.25605 12.4466 6.97461 12.8429 6.97461C13.2393 6.97461 13.5609 7.25605 13.5609 7.60281V13.8849C13.5609 14.2316 13.2393 14.5131 12.8429 14.5131Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.8429,
    cy: 16.3977,
    rx: 0.717949,
    ry: 0.628205,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1385643518ce1e48f1cb3af3c8f2f9ba.svg";
export { ForwardRef as ReactComponent };